var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropPicture = function SvgDropPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82471 33.5935C5.82471 31.0866 7.85692 29.0544 10.3638 29.0544H64.8327C67.3396 29.0544 69.3718 31.0866 69.3718 33.5935V78.9843C69.3718 81.4911 67.3396 83.5234 64.8327 83.5234H10.3638C7.85692 83.5234 5.82471 81.4911 5.82471 78.9843V33.5935Z",
    fill: "#F2F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82471 72.864V78.4939C5.82471 81.0007 7.85692 83.0329 10.3638 83.0329H17.1196V78.0812H10.7764V72.864H5.82471ZM17.1196 28.564H10.3638C7.85692 28.564 5.82471 30.5962 5.82471 33.1031V38.7329H10.7764V33.5157H17.1196V28.564ZM5.82471 68.9935H10.7764V57.7337H5.82471V68.9935ZM5.82471 53.8632H10.7764V42.6035H5.82471V53.8632ZM21.7643 28.564V33.5157H35.2759V28.564H21.7643ZM39.9206 28.564V33.5157H53.4323V28.564H39.9206ZM58.0769 28.564V33.5157H64.4201V38.7329H69.3718V33.1031C69.3718 30.5962 67.3396 28.564 64.8327 28.564H58.0769ZM69.3718 42.6035H64.4201V53.8632H69.3718V42.6035ZM69.3718 57.7337H64.4201V68.9935H69.3718V57.7337ZM69.3718 72.864H64.4201V78.0812H58.0769V83.0329H64.8327C67.3396 83.0329 69.3718 81.0007 69.3718 78.4939V72.864ZM53.4323 83.0329V78.0812H39.9206V83.0329H53.4323ZM35.2759 83.0329V78.0812H21.7643V83.0329H35.2759Z",
    fill: "#65748C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 6.5,
    width: 61,
    height: 60,
    rx: 7,
    fill: "#F2F5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 9,
    width: 56,
    height: 55,
    rx: 4.5,
    stroke: "#65748C",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3253 18.8983C60.5175 17.7061 62.1344 17.0364 63.8204 17.0364C65.5064 17.0364 67.1233 17.7061 68.3155 18.8983C69.5076 20.0905 70.1774 21.7074 70.1774 23.3934C70.1774 25.0794 69.5076 26.6963 68.3155 27.8885C67.1233 29.0806 65.5064 29.7504 63.8204 29.7504C62.1344 29.7504 60.5175 29.0806 59.3253 27.8885C58.1331 26.6963 57.4634 25.0794 57.4634 23.3934C57.4634 21.7074 58.1331 20.0905 59.3253 18.8983Z",
    fill: "#65748C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 54.5L71.5625 45.0086L69.6217 46.8622C68.3794 48.0485 66.6942 48.7152 64.9375 48.7152C63.1808 48.7152 61.496 48.0488 60.2536 46.8626L50.7169 37.7539C50.0958 37.161 49.2532 36.8276 48.375 36.8276C47.4968 36.8276 46.6546 37.1607 46.0334 37.7536L28.5 54.5V45.5514L41.3488 33.2793C43.2124 31.4999 45.7399 30.5 48.375 30.5C51.0101 30.5 53.5373 31.4996 55.4008 33.279L64.9375 42.3876L66.8783 40.5339C68.1206 39.3477 69.8058 38.6809 71.5625 38.6809C73.3192 38.6809 75.004 39.3473 76.2464 40.5336L81.5 45.5514V54.5Z",
    fill: "#65748C"
  })));
};
export default SvgDropPicture;